// Opção "TODOS" dos filtros de Regional e Distrito do relatório.
export const ALL_OPTION = -1

export const ALL_OPTION_ITEM = { value: ALL_OPTION, description: ' TODOS' }

export const isAllOption = (value) => String(value) === String(ALL_OPTION)

export const hasAllOption = (selection = []) => Array.isArray(selection) && selection.some(isAllOption)

export const getOptionIds = (options = []) => options.map(({ value }) => value).filter((value) => !isAllOption(value))

// Remove o "TODOS" vindo da API, mantém apenas as opções do escopo do usuário (quando informado)
// e adiciona "TODOS" quando houver mais de uma opção.
export const prepareOptions = (options = [], allowedIds = null) => {
  const allowedSet = allowedIds ? new Set(allowedIds.map(String)) : null

  const items = options.filter(({ value }) => !isAllOption(value) && (!allowedSet || allowedSet.has(String(value))))

  return items.length > 1 ? [ALL_OPTION_ITEM, ...items] : items
}

// "TODOS" é exclusivo: ao marcá-lo, substitui as opções individuais; ao marcar uma individual depois dele,
// o "TODOS" sai. Remover o "TODOS" limpa a seleção.
export const applyAllOptionSelection = (selection = [], previousSelection = []) => {
  if (!hasAllOption(selection)) return selection

  if (!hasAllOption(previousSelection)) return [ALL_OPTION]

  return selection.filter((value) => !isAllOption(value))
}

export const resolveSelectionIds = (selection = [], options = []) =>
  hasAllOption(selection) ? getOptionIds(options) : selection

// Usado na montagem da requisição: troca "TODOS" pelos IDs resolvidos e descarta qualquer -1 remanescente.
export const toRequestIds = (selection, resolvedIds = []) => {
  if (!Array.isArray(selection)) return selection

  const ids = hasAllOption(selection) ? resolvedIds || [] : selection

  return ids.filter((value) => !isAllOption(value))
}
